const paddy = (num, places = 2) => {
  return ("" + num).padStart(places, '0');
}

// Is Same Date Only (ignore hours)
const isSameDate = (date1, date2) => {
  return date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate();
}

const isSameHourMin = (d1, d2) => {
  return d1.getHours() === d2.getHours() && d1.getMinutes() === d2.getMinutes();
}

export default function useDisplayTime() {

  const displayTimestamp = (timestamp, withSeconds = false, withYear=false) => {
    const givenDate = new Date(timestamp);
    const sec = withSeconds ? `:${paddy(givenDate.getSeconds())}` : '';
    const timeDisplay = `${paddy(givenDate.getHours())}:${paddy(givenDate.getMinutes())}${sec}`;
    const now = new Date();

    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);

    //const weekDay = givenDate.getDay
    let dateDisplay;
    if (isSameDate(givenDate, now)) {
      dateDisplay = 'Today'
    }
    else if (isSameDate(givenDate, yesterday)) {
      dateDisplay = 'Yesterday'
    }
    else {
      dateDisplay = givenDate.toLocaleDateString('en-US', {month: withYear ? 'long':'short', day:'2-digit', year: withYear ? 'numeric' : '2-digit', weekday: withYear?'long':'short'});
    }
    
    return dateDisplay + ' ' + timeDisplay;
  }

  const compressedTimestamp = (timestamp) => {
    const d = new Date(timestamp);

    const result = `${d.getFullYear()}-${paddy(d.getMonth()+1)}-${paddy(d.getDate())} ${d.getHours()}:${paddy(d.getMinutes())}:${paddy(d.getSeconds())}.${paddy(d.getMilliseconds(),3)}`;

    return result;
  }


  const significantTime = (timestamp) => {
    const d = new Date(timestamp);
    const now = new Date();

    let year = '';
    let monthDay = paddy(d.getMonth() + 1) + '/' + paddy(d.getDate());
    let hourMin = '';    

    if (d.getFullYear() === now.getFullYear()) {
      if (d.getMonth() === now.getMonth()) {
        if (d.getDate() === now.getDate()) {
          monthDay = 'Today, ';
          if (isSameHourMin(d, now)) {
            hourMin = 'Now';
          }
          else {
            hourMin = d.getHours() + ':' + paddy(d.getMinutes());
          }
        }
      }
    }
    else {
      monthDay = '-' + paddy(d.getMonth() + 1);
      year = paddy(d.getFullYear());
    }

    return year+monthDay+hourMin;
  }

  const asDigitalWatch = (timestamp) => {
    const d = new Date(timestamp);
    return `${paddy(d.getMinutes())}:${paddy(d.getSeconds())}`;
  }

  return {
    displayTimestamp, 
    compressedTimestamp,
    significantTime,
    paddy,
    asDigitalWatch
  }
}